export default function setRandom() {
  const randomElement = document.querySelector("[data-random]");

  if (!randomElement) return;

  const randomNumber = Math.floor(Math.random() * (20 - 10 + 1)) + 10;

  randomElement.textContent = randomNumber;
}
